import escapeRegExp from 'util/escapeRegExp';

const SPECIAL_CHARACTERS: Record<string, string> = {'*': '.*', '?': '.'};

export default function sanitizeRegex(input: string): string {
  return (
    // Sanitize special characters in the input
    escapeRegExp(input)
      // Undo sanitizing the * and ? because we treat those characters specially (as wildcards)
      .replace(/\\\*/g, '*')
      .replace(/\\\?/g, '?')
      // Replace any unescaped * and ? with .* and . respectively
      .replace(/(~*)(.)/g, (_match: string, tildes: string, character: string) => {
        if (tildes.length % 2 === 0) {
          // An even number of preceding tildes means the tildes all escape each other.
          // Therefore, the character is unescaped and should be treated as a wildcard
          const characterReplacement = SPECIAL_CHARACTERS[character] ?? character;
          return tildes + characterReplacement;
        } else {
          // The character should be escaped (i.e. not treated as a wildcard)
          // Note: like Excel, ~ also escapes non-special characters, so "~a" is treated as "a"
          const characterReplacement = Object.keys(SPECIAL_CHARACTERS).includes(character)
            ? `\\${character}`
            : character;
          // Reduce the number of tildes by one (consume the escaping tilde)
          return tildes.slice(1) + characterReplacement;
        }
      })
      // Replace escaped tildes (~~)
      .replace(/~~/g, '~')
  );
}
